import { createSlice } from '@reduxjs/toolkit'

export const loginModalSlice = createSlice({
  name: 'loginModal',
  initialState: {
    show: false,
    user: {
      firstName: '',
      email: ''
    }
  },
  reducers: {
    showLoginModal: (state, action) => {
      state.show = true;
      state.user = action.payload;
    },
    hideLoginModal: (state) => {
      state.show = false;
    }
  },
})

export const { showLoginModal, hideLoginModal } = loginModalSlice.actions

export default loginModalSlice.reducer
